export default async function GetPlotSequenceByPlotSpecificationId(id) {
    let url = window.RealestateService + `/api/ProjectPlotDetails/GetPlotSequenceByPlotSpecificationId?id=${id}`
    let head = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response
}